/** Logging & Debugging */
export default /* @ngInject */ function debug($compileProvider, $logProvider, configProvider) {
    $logProvider.debugEnabled(configProvider.debug);
    $compileProvider.debugInfoEnabled(configProvider.debug);
}



// WEBPACK FOOTER //
// ./config/debug.js